<template>
	<div v-if="loading" class="dashboard-home-bar-pro">
    <div class="loader-wrapper">
      <div class="loader big"></div>
    </div>
	</div>

	<div v-else-if="home" class="dashboard-home-bar-pro">
    <div class="nav__back" v-if="$route.name === 'DashboardProSubscriptions' || $route.name === 'DashboardProAdvert' || $route.name === 'DashboardProDocuments' || $route.name === 'DashboardProDiagnostics'">
      <router-link :to="{ name: 'DashboardProHomes' }">
        Retour aux biens
      </router-link>
    </div>

    <mangopay-actions :user="user" />

    <!-- Summary -->
    <div class="summary">
      <div v-if="home.image_orders && home.image_orders.length > 0" class="photo">
        <img :src="`/image/${home.image_orders[0]}/1000/0`" alt="Photo logement" />
      </div>
      <div v-else class="photo">
        <img src="/static/images/icons/no-picture.svg" alt="Photo logement" />
      </div>
      <div class="description">
        <router-link class="title" v-if="$route.name !== 'DashboardProSubscriptions'"
                     :to="{ name: 'DashboardProSubscriptions', query: { home_id: home.id } }">
          <label style="cursor: pointer">{{home.name}}</label>
        </router-link>
        <div v-else class="title nocursor">
          <label>{{home.name ? home.name : 'ANNONCE INCOMPLETE'}}</label>
        </div>
        <div class="content">
          <div class="details">
            <div class="address" v-if="home.address || home.city">
              <p v-if="home.address">{{ home.address }}</p>
              <p v-if="home.address2">{{ home.address2 }}</p>
              <p v-if="home.city">{{ fullCity }}</p>
            </div>
            <div class="status">
              <div class="tags">
                <div v-if="home.step < 3">Incomplète</div>
                <div v-if="home.mandate_status === 'complete'">Mandat en cours</div>
                <div v-else-if="home.mandate_status === 'signing'">Mandat à signer</div>
                <div v-else-if="home.mandate_status === 'signed'">Mandat en attente Cooloc</div>
                <div v-if="home.published">Publiée</div>
                <div v-else-if="home.moderation_status === 'pending'" class="tag-warning">En cours de modération</div>
                <div v-else>Non publiée</div>
              </div>
            </div>
            <div class="actions" v-if="home.step >= 3">
              <router-link v-if="home.moderation_status === 'pending' && home.offer && home.user_id === user.id
                && home.offer.startsWith('mandate')" :to="{ name: proType, params: { home_id: home.id, path: 'annonce-moderation' } }" title="Compléter">
                Compléter le profil {{ proType === 'agent' ? 'agent' : 'bailleur' }}
              </router-link>
              <div v-else>
                <a :href="home.public_url" class="public_link" target="_annonce">Annonce publique</a>
                <span class="copy_link" @click="copyLink(home.public_url)">(copier le lien)</span>
              </div>
              <router-link :to="{ name: 'DashboardPreviewAdvert', params: { home_id: home.id } }" title="Aperçu">
                Aperçu
              </router-link>
            </div>
            <div class="actions" v-else>
              <router-link :to="{ name: proType, params: { home_id: home.id, path: 'annonce-adresse' } }" title="Compléter">
                Compléter
              </router-link>
              <span v-if="hasAccessAdvert" @click="modalDelete = true" title="Supprimer">
                Supprimer l'annonce
              </span>
            </div>
          </div>
          <div v-if="home.step >= 3 && !isOwnerColoc && owners" class="owners">
            <div v-if="owners.length > 0">
              <h4>Bailleurs&nbsp;:</h4>
              <p v-for="o of owners" :key="'owner-' + (o.id ? o.id : o.email)">
                {{ o.first_name || o.name ? (o.first_name + ' ' + o.name).trim() : o.email }}
                  <span class="pending" v-if="o.pending && !o.invite_expired">(invitation envoyée)</span>
                  <span v-else-if="o.pending && o.invite_expired"
                    @click="resendInviteOwner(o)">(renvoyer l'invitation)</span>
              </p>
            </div>
            <div v-else class="owners">
              Aucun bailleur défini
            </div>
          </div>
        </div>
      </div>
    </div>

    <ui-modal v-if="modalDelete" @close="modalDelete = false" title="Supprimer l'annonce">
      Voulez-vous vraiment supprimer cette annonce ?
      <template slot="buttons">
        <ui-button class="button-gray" @click="!deleting && (modalDelete = false)">Non</ui-button>
        <ui-button :loading="deleting" w="150px"
                   @click="!deleting && deleteHome()">Oui</ui-button>
      </template>
    </ui-modal>

    <ui-modal v-if="invite.modal" @close="invite.modal = false" title="Inviter un bailleur">
      <div>
        <p style="text-align: left">Veuillez entrer l'adresse email du bailleur que vous souhaitez inviter pour ce bien :</p>
        <div class="form-e-mail">
          <input
            type="email"
            id="form-invite-e-mail"
            name="email"
            :class="{ error: $v.invite.email.$invalid && invite.errorcheck }"
            placeholder="Adresse e-mail"
            v-model="invite.email"
            v-on:input="$v.invite.email.$touch">
          <span class="texterror" v-if="!$v.invite.email.required && invite.errorcheck">Champ obligatoire.</span>
          <span class="texterror" v-if="!$v.invite.email.email && invite.errorcheck">Cet email ne semble pas valide.</span>
        </div>
      </div>
      <template slot="buttons">
        <ui-button class="button-gray" @click="!invite.pending && (invite.modal = false)">Annuler</ui-button>
        <ui-button :loading="invite.pending" w="150px"
                  @click="!invite.pending && inviteOwner()">Inviter</ui-button>
      </template>
    </ui-modal>

    <ui-modal v-if="invite.sentModal" @close="invite.sentModal = false" title="Invitation envoyée">
      <div>
        <p style="text-align: left">Un e-mail d'invitation vient d'être envoyé à {{ invite.email }}.</p>
        <p style="text-align: left">Le lien sera valide pendant 7 jours.</p>
      </div>
      <template slot="buttons">
        <ui-button @click="invite.sentModal = false" w="150px">OK</ui-button>
      </template>
    </ui-modal>
	</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'
import { fetchDataHome, registrationHelpers } from '@/main'
import { optionFields } from '@/components/mixins/optionFields'
import home1 from '../registration-v2/Home-1.vue'

export default {
  mixins: [validationMixin, optionFields],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    home: null,
    modalDelete: false,
    deleting: false,
    invite: {
      modal: false,
      email: '',
      pending: false,
      errorcheck: false,
      sentModal: false,
    },
  }),
  validations: {
    invite: {
      email: {
        required,
        email,
      },
    },
  },
  mounted() {
    this.load()
  },
  computed: {
    home1() {
      return home1
    },
    isOwner() {
      return this.user.type === 2 || this.user.type === 4 || (this.user.type === 1 && this.user.home && !this.home.is_coloc)
    },
    proType() {
      return this.user && registrationHelpers.userTypes.is(this.user, 'agent') ? 'agent' : 'proprietaire'
    },
    isOwnerColoc() {
      return this.user.type === 1 && this.user.home && !this.home.is_coloc
    },
    owners() {
      if (!this.home.owners_roles) return []
      const owners = this.home.owners_roles.filter(o => o.role === 'owner' && !o.pending)
      owners.sort((o1, o2) => {
        const m1 = !o1.pending ? 0 : (o1.name ? 1 : 2)
        const m2 = !o2.pending ? 0 : (o2.name ? 1 : 2)
        if (m1 === m2) {
          return o2.name < o1.name ? 1 : -1
        }
        return m1 > m2 ? 1 : -1
      })
      return owners
    },
    hasAccessAdvert() {
      return this.isOwner || (this.user.type === 8 && (this.home.notifications_advert === 2 || this.home.notifications_advert === 3 || (this.home.notifications_advert === 0 && this.home.offer === 'mandate-79')))
    },
    fullCity() {
      let location = ''
      if (this.home.postal_code) {
        location = this.home.postal_code.trim()
      }
      if (this.home.city) {
        location = (location + ' ' + this.home.city).trim()
      }
      if (this.home.country) {
        location = (location + ', ' + this.getFieldName(this.home.country, 'country')).trim()
      }
      return location
    },
  },
  methods: {
    load(homeId) {
      if (this.user && this.isOwnerColoc) {
        this.loading = false
        return
      }

      this.loading = true
      const requested_home_id = homeId || this.$route.query.home_id || 'default'
      fetchDataHome(this, requested_home_id)
        .then(home => {
          this.home = home
          if (requested_home_id === 'default' && home) {
            this.$router.replace({ name: this.$route.name, query: { home_id: home.id } })
          }
        })
        .finally(() => this.loading = false)
    },
    copyLink(link) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link && (link.startsWith('http://') || link.startsWith('https://')) ? link : window.location.origin + link)
      }
    },
    deleteHome() {
      this.deleting = true
      this.$http.delete(`/api/homes/${this.home.id}`)
        .then(() => {
            const { home_id, ...query } = this.$route.query
            query.home_id = home_id !== this.home.id ? home_id : undefined
            this.$router.push({ name: 'DashboardProHomes', query })
          },
          err => {
            console.error(err)
            this.deleting = false
          },
        )
    },
    openInviteOwner() {
      this.invite.errorcheck = false
      this.invite.email = ''
      this.invite.modal = true
    },
    resendInviteOwner(owner) {
      this.$http
        .post(`/api/homes/${this.home.id}/invite?force=true`, {
          owner_email: owner.email,
          owner_role: owner.role,
        })
        .then(
          () => {
            owner.expired = false
          },
          err => {
            this.$error(err)
          },
        )
    },
    inviteOwner() {
      this.invite.errorcheck = true
      if (this.$v.invite.$invalid) {
        return
      }
      this.invite.pending = true
      this.$http
        .post(`/api/homes/${this.home.id}/invite?force=true`, {
          owner_email: this.invite.email,
          owner_role: 'owner',
        })
        .then(
          res => {
            console.log('Owner: ' + JSON.stringify(res.data))
            this.invite.modal = false
            const index = this.home.owners_roles.findIndex(r => r.id === res.data.owner_id || r.email === res.data.email)
            if (index >= 0) {
              this.home.owners_roles[index] = res.data
            } else {
              this.home.owners_roles.push(res.data)
            }
            this.invite.sentModal = true
          },
          err => {
            this.$error(err)
          },
        )
        .finally(() => this.invite.pending = false)
    },
  },
  components: {
    UiModal: require('@/ui/Modal').default,
    UiButton: require('@/ui/Button').default,
    MangopayActions: require('../dashboard/pages/pro/mangopay-actions').default,
    //   HomeAutocomplete,
  },
}
</script>

<style lang="scss">

.form-e-mail {
  input.error {
    border: 1px solid $red;
  }
}

.dashboard-home-bar-pro {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  margin-bottom: 8px;

  .loader-wrapper {
    display: flex;
    height: 224px;
    // min-height: 80px;
    justify-content: center;
  }

  .nav__back {
    display: flex;
    height: 44px;
    cursor: pointer;
    margin-bottom: 8px;

    a {
      background: url('../../../static/images/icons/left.svg') left center no-repeat;
      background-size: 20px 16px;
      padding: 8px 0 8px 24px;
      color: $gray1 !important;
      line-height: 24px;
    }
  }

  .summary {
    border: 1px solid #D9D9D9;
    background-color: white;
    padding: 16px;
    width: 100%;
    display: flex;
    column-gap: 32px;

    .photo {
      img {
        width: 300px;
        max-width: 300px;
        height: 180px;
        object-fit: cover;
      }
    }
    .description {
      flex: 1;
      line-height: 20px;

      .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        > label {
          flex: 1;
          font-size: 24px;
          font-weight: 600;
          line-height: 28px;
          color: #D90E16;
        }

        > div {
          flex: 280px 0 0;
          width: 280px;
          max-width: 280px;
        }
      }

      .content {
        display: flex;
        flex-direction: row;
        gap: 16px;
        .details {
          flex: 1;
        }
        .owners {
          flex: 0 0 320px;
          margin-top: 16px;
          h4 {
            font-size: 16px;
            line-height: 1.5;
          }
          .pending {
            margin-left: 8px;
            color: $blue;
          }
          .actions {
            margin-top: 16px;
          }
        }
      }

      .address {
        margin-top: 16px;
      }

      .status {
        font-size: 16px;
        margin: 16px 0;
        color: $blue;

        .tags {
          display: flex;
          align-items: flex-start;
          flex-direction: row;
          flex-wrap: wrap;
          column-gap: 16px;
          row-gap: 12px;
        }
        .tags > div {
          padding: 8px;
          background: #F0F2F5;
          color: #000000;
        }
        .tags > div.tag-warning {
          background-color: rgba(255,251,230,1);
        }

        a.public_link {
          font-weight: 300;
          font-size: 16px;
        }
      }

      .actions {
        display: flex;
        flex-direction: row;
        column-gap: 32px;
        a, > span {
          color: $red2;
          cursor: pointer;
          &.bold {
            font-weight: 600;
          }
        }
      }
    }
  }
  .copy_link {
    cursor: pointer;
    font-size: 16px;
    color: $blue;
  }

  /*********************************************************************************************************************************************************/
	/*                                                                TABLET & PHONE                                                                         */
	/*********************************************************************************************************************************************************/
	@media #{$tablet} {
		margin: 0;
	}

  @media #{$phone} {
    .summary {
      flex-direction: column;
      row-gap: 16px;

      .photo {
        img {
          min-width: 100%;
          width: 100%;
        }
      }

      .description {
        .title {
          flex-direction: column-reverse;
          row-gap: 16px;

          > div {
            flex: 32px 0 0;
          }
        }

        .content {
          flex-direction: column;
          .owners {
            flex: 0;
          }
        }
      }
    }
  }
}
</style>
